import React from 'react';
import { Helmet } from 'react-helmet-async';
import { Plus } from 'lucide-react';

/* FAQ accordion with FAQPage JSON-LD schema injected via Helmet — light theme */
export const FaqSection = ({ faqs, heading = 'Questions, answered.' }) => {
  const schema = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: faqs.map((f) => ({
      '@type': 'Question',
      name: f.q,
      acceptedAnswer: { '@type': 'Answer', text: f.a },
    })),
  };
  return (
    <section className="relative py-24 md:py-32 px-6 md:px-10 bg-[#D9E9FC]" data-testid="faq-section">
      <Helmet>
        <script type="application/ld+json">{JSON.stringify(schema)}</script>
      </Helmet>
      <div className="max-w-3xl mx-auto">
        <p className="font-body text-[11px] uppercase tracking-[0.25em] text-gray-500 mb-4">FAQ</p>
        <h2 className="font-display font-extrabold tracking-tighter text-[clamp(2rem,5vw,3.5rem)] leading-tight text-transparent bg-clip-text bg-gradient-to-br from-gray-900 via-gray-600 to-gray-900 mb-12">
          {heading}
        </h2>
        <div className="space-y-3">
          {faqs.map((f, i) => (
            <details key={i} className="group rounded-2xl border border-gray-200 bg-white shadow-sm open:shadow-md open:border-gray-300 transition-[box-shadow,border-color]" data-testid={`faq-item-${i}`}>
              <summary className="flex items-center justify-between gap-4 cursor-pointer list-none p-5 font-body text-sm md:text-base font-semibold text-gray-900 [&::-webkit-details-marker]:hidden">
                {f.q}
                <Plus className="w-4 h-4 text-gray-400 flex-shrink-0 transition-transform group-open:rotate-45" />
              </summary>
              <p className="font-body text-sm text-gray-600 leading-relaxed px-5 pb-5 -mt-1">{f.a}</p>
            </details>
          ))}
        </div>
      </div>
    </section>
  );
};
